import { DataService } from "base/services";
import { useAccountStore } from "base/stores";

export const ApikeyService = {
  getApiKeys() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(
      `/user/2/${accountId}/api?page_number=1&page_size=50`
    );
  },

  deleteApiKey(apiKey) {
    const accountId = useAccountStore.getState()._id;
    return DataService.delete(`/user/2/${accountId}/api/${apiKey}`);
  },

  getDebugAPIKey() {
    const accountId = useAccountStore.getState()._id;
    return DataService.get(`/user/2/${accountId}/debug/key`);
  },

  createDebugKey() {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/user/2/${accountId}/debug/key`);
  },

  createApiKey(details) {
    const accountId = useAccountStore.getState()._id;
    return DataService.post(`/user/2/${accountId}/api/`, { data: details });
  },

  updateApiKey(apiKey, details) {
    const accountId = useAccountStore.getState()._id;
    return DataService.update(`/user/2/${accountId}/api/${apiKey}`, {
      data: details
    });
  }
};
